(() => {
  const faqSelector = ".main-article__body .wysn-article__faq";
  const triggerSelector = `${faqSelector} .wt-collapse__trigger`;
  const activeClass = "wt-collapse__trigger--active";

  const getFaqItem = (trigger) =>
    trigger.closest("collapsible-section, .wt-collapse") || trigger.parentElement;

  const setState = (trigger, isOpen) => {
    const item = getFaqItem(trigger);

    trigger.classList.toggle(activeClass, isOpen);
    trigger.dataset.open = String(isOpen);
    trigger.setAttribute("aria-expanded", String(isOpen));

    if (item) item.dataset.open = String(isOpen);
  };

  const toggle = (trigger) => {
    const isOpen =
      trigger.classList.contains(activeClass) ||
      trigger.getAttribute("aria-expanded") === "true";

    setState(trigger, !isOpen);
  };

  const findTrigger = (target) =>
    target instanceof Element ? target.closest(triggerSelector) : null;

  document.addEventListener(
    "click",
    (event) => {
      const trigger = findTrigger(event.target);
      if (!trigger) return;

      // Handle article FAQs here so the theme custom element cannot toggle twice.
      event.stopPropagation();
      toggle(trigger);
    },
    true,
  );

  document.addEventListener(
    "keydown",
    (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;

      const trigger = findTrigger(event.target);
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      toggle(trigger);
    },
    true,
  );

  document.querySelectorAll(triggerSelector).forEach((trigger) => {
    trigger.setAttribute("role", "button");
    trigger.setAttribute("tabindex", "0");
    setState(trigger, trigger.getAttribute("aria-expanded") === "true");
  });
})();
